<nz-spin [nzSpinning]="loading$ | async"
  ><form nz-form class="form">
    <div class="drawer-form-wrapper without-bottom-cta">
      <div class="header-with-cta without-border">
        <div class="cta-wrapper">
          <app-organization-search
            [isNullable]="false"
            [defaultSelectedOrg]="orgId"
            (orgChange)="orgChange($event)">
          </app-organization-search>
          <nz-input-group [nzPrefix]="suffixIconSearch">
            <input
              name="warningValid"
              type="text"
              nz-input
              id="selectStudent"
              [formControl]="searchTitle"
              placeholder="Search" />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span nz-icon nzType="search"></span>
          </ng-template>
          <button
            type="button"
            nz-button
            nzType="default"
            class="primary-outlined"
            (click)="openFilterDrawer()">
            <svg-icon
              src="/assets/icon/icon-filter.svg"
              class="icon s-14"></svg-icon>
            Filter
            {{ appliedFilterLength ? '(' + appliedFilterLength + ')' : '' }}
          </button>
          <button
            nz-button
            type="button"
            nzType="text"
            class="primary-text-btn"
            [disabled]="!appliedFilterLength"
            (click)="clearFilters()">
            <svg-icon src="/assets/icon/icon-clear.svg" class="icon s-14">
            </svg-icon>
            Clear
          </button>
        </div>
      </div>
      <nz-table
        #sortTable
        nzShowSizeChanger
        [nzData]="(templateLogs$ | async)?.result?.items ?? []"
        [nzFrontPagination]="false"
        [nzTotal]="(templateLogs$ | async)?.result?.totalRows || 0"
        [(nzPageIndex)]="pageIndex"
        [nzPageSize]="pageSize"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzScroll]="{ x: '1200', y: 'calc(100vh - 354px)' }">
        <thead>
          <tr>
            <th
              nzWidth="250px"
              [nzSortFn]="true"
              [title]="listOfColumn[0].title"
              [nzColumnKey]="listOfColumn[0].key">
              {{ listOfColumn[0].title }}
            </th>
            <th
              nzWidth="150px"
              [nzSortFn]="true"
              [title]="listOfColumn[1].title"
              [nzColumnKey]="listOfColumn[1].key">
              {{ listOfColumn[1].title }}
            </th>
            <th
              nzWidth="120px"
              [nzSortFn]="true"
              [title]="listOfColumn[2].title">
              {{ listOfColumn[2].title }}
            </th>
            <th
              nzWidth="150px"
              [title]="listOfColumn[3].title"
              [nzColumnKey]="listOfColumn[3].key">
              {{ listOfColumn[3].title }}
            </th>
            <th
              nzWidth="120px"
              [nzSortFn]="true"
              [title]="listOfColumn[4].title"
              [nzColumnKey]="listOfColumn[4].key">
              {{ listOfColumn[4].title }}
            </th>
            <th
              nzWidth="130px"
              [nzSortFn]="true"
              [title]="listOfColumn[5].title"
              [nzColumnKey]="listOfColumn[5].key">
              {{ listOfColumn[5].title }}
            </th>
            <th nzWidth="70px" nzRight>{{ listOfColumn[6].title }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of sortTable.data; let i = index">
            <td>
              {{ data.title }}
            </td>
            <td class="with-icon">
              {{ data.templateName }}
            </td>
            <td [title]="data.auditType">
              <div
                class="status added"
                *ngIf="data.auditType === AuditTypeEnums.CREATE">
                <span>Added</span>
              </div>
              <div
                class="status updated"
                *ngIf="data.auditType === AuditTypeEnums.UPDATE">
                <span>Updated</span>
              </div>
              <div
                class="status deleted"
                *ngIf="data.auditType === AuditTypeEnums.DELETE">
                <span>Deleted</span>
              </div>
            </td>
            <td [title]="data.userName">{{ data.userName }}</td>
            <td [title]="data.time | userDate: 'hh:mm a'">
              {{ data.time | userDate: 'hh:mm a' }}
            </td>
            <td [title]="data.date | userDate: 'MM/dd/yyyy'">
              {{ data.date | userDate: 'MM/dd/yyyy' }}
            </td>
            <td nzRight>
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  nzType="text"
                  type="button"
                  (click)="openTemplateLogDetailsDrawer(data)">
                  <svg-icon
                    [title]="'View template log'"
                    src="/assets/icon/icon-eye.svg"
                    class="icon s-20"></svg-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </form>
  <ng-template #drawerLogDetail>
    <app-drawer-header
      [title]="'Log Details'"
      subtitle="Log Details"
      [breadcrumbText]="'BIP Template'"
      (close)="closeLogDetailDrawer()">
    </app-drawer-header>
  </ng-template>
</nz-spin>
